import React from 'react';
import './FormStyles.css';
import './Input.css';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

class InputBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      touched: false,
      focused: false,
    };
  }

  handleBlur = (evt) => {
    const { onBlur } = this.props;

    this.setState({
      touched: true,
      focused: false,
    });

    if (onBlur) {
      onBlur(evt);
    }
  };

  handleFocus = (evt) => {
    const { onFocus, required, translate } = this.props;
    this.setState({
      focused: true,
    });

    if (onFocus) {
      onFocus(evt);
    }
    if(required && evt.target.value === '') {
      evt.target.setCustomValidity(translate('service_installation.time_not_selected'));
    } else if(evt.target.value !== '') {
      evt.target.setCustomValidity('');
    }
  };

  handleChange = (evt) => {
    const { onChange, required, translate } = this.props;

    this.setState({
      value: evt.target.value,
    });

    if (onChange) {
      onChange(evt);
    }
    if(required && evt.target.value === '') {
      evt.target.setCustomValidity(translate('service_installation.time_not_selected'));
    } else if(evt.target.value !== '') {
      evt.target.setCustomValidity('');
    }
  };

  validate() {
    const { required } = this.props;

    const errors = {};

    if (required) {
      if (!this.state.value) {
        errors.required = 'vaadittu kenttä';
      }
    }

    return Object.keys(errors).length
      ? errors
      : null;
  }

  get attributes() {
    const { className, required } = this.props;
    const { value, touched, focused, } = this.state;

    const errors = this.validate(value);
    const showErrors = errors && touched;

    const errorClassName = showErrors && !focused
      ? 'form-input-error'
      : '';
    return {
      'iso-latin-only': '',
      ...this.props,
      className: `${className || ''} ${errorClassName}`,
      'aria-required': !!required,
      'aria-invalid': (showErrors && !focused),
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      onKeyPress: this.handleChange
    };
  }

  render() {
    if (true) {
      throw new Error('InputBase.render function not implemented');
    }
    return null;
  }
}

class Input extends InputBase {
  isButton() {
    const { type } = this.props;

    return (type === 'submit' || type === 'reset' || type === 'button');
  }

  render() {
    let { attributes } = this;
    const { className } = attributes;

    const inputClass = this.isButton()
      ? 'form-button form-input-shadow'
      : 'form-input';
    attributes = {
      type: 'text',
      ...attributes,
      className: `text-5 ${inputClass} ${className}`,
    };

    return (
      <input {...attributes} />
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code
});

export { InputBase };
export default connect(
  mapStateToProps,
  null,
)(Input);



// WEBPACK FOOTER //
// ./src/components/forms/Input.js